export default __webpack_public_path__ + "static/media/component_toggle_right_info.427365a3.svg";